document.addEventListener('click', function (e) {
  var btn = e.target.closest('.at-pair-with__add');
  if (!btn) return;
  var variantId = btn.getAttribute('data-variant-id');
  if (!variantId || btn.disabled) return;
  btn.disabled = true;
  var originalText = btn.textContent;
  btn.textContent = '...';
  fetch(window.routes.cart_add_url + '.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
  })
    .then(function (r) { return r.json(); })
    .then(function () {
      btn.textContent = 'Added';
      var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      if (cart && cart.getSectionsToRender) {
        var sectionIds = cart.getSectionsToRender().map(function (s) { return s.id; });
        fetch(window.routes.cart_url + '?sections=' + sectionIds.join(','))
          .then(function (r) { return r.json(); })
          .then(function (sections) {
            cart.renderContents({ sections: sections });
          });
      } else {
        window.location.href = window.routes.cart_url;
      }
      setTimeout(function () {
        btn.textContent = originalText;
        btn.disabled = false;
      }, 2000);
    })
    .catch(function () {
      btn.textContent = originalText;
      btn.disabled = false;
    });
});
